module.exports = __webpack_public_path__ + "img/activities-tour.8cc696b0.jpg";